<template>
  <div :class="{ 'mt-30-px': !showNavbar }">
    <notifications></notifications>
    <navbar v-if="showNavbar" :title="$t('global.batixsoftware')"></navbar>

    <ValidationObserver v-slot="{ invalid }">
      <div class="container-fluid row">
        <div v-if="showNavbar" class="col-xl-12">
          <div class="row">
            <div class="col-xl-12 block br-t-l-0 mb-3">
              <head-menu
                :col="12"
                class="d-xl-flex"
                :headline="navbarTitel"
              ></head-menu>
              <div class="row mt-2 d-flex justify-content-between">
                <div class="ml-4 mr-2">
                  <button
                    v-if="editable"
                    v-shortkey.once="['ctrl', 's']"
                    class="btn btn-success mr-2"
                    :disabled="invalid"
                    @click="speichern"
                    @shortkey="speichern"
                  >
                    {{ $t("global.save") }}
                  </button>
                  <button class="btn btn-primary mr-2" @click="abbrechen">
                    <font-awesome-icon icon="fa-solid fa-list" class="mr-2" />{{
                      $t("global.tolist")
                    }}
                  </button>
                </div>
                <div class="mr-4">
                  <button
                    class="btn btn-danger"
                    @click="oeffneLoeschenModal"
                    v-if="berechtigungen.m_anmeldungen.delete && produktid"
                  >
                    <font-awesome-icon
                      class="mr-1"
                      icon="fa-duotone fa-trash"
                    />
                    <span>{{ $t("global.delete") }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- START Linke Seite -->
        <div class="col-xl-6 pr-4" :class="{ 'col-xl-12': !showNavbar }">
          <!-- START Stammdaten -->

          <container-headline
            :headline="$t('global.masterdata')"
            :col="6"
          ></container-headline>
          <div class="row mb-3">
            <!--
              <div class="col-xl-12 block br-t-l-0">
                <div class="eingabe-panel-kopf p-3">
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="row">
                        <div class="col-xl-12">
                          <div class="form-group">
                            <ValidationProvider
                              rules="required"
                              immediate
                              v-slot="{ passed }"
                            >
                              <v-select
                                v-model="anmeldung.anmeldestatus"
                                label="bezeichnung"
                                v-bind:class="{ 'border-info': !passed }"
                                :options="anmeldestati"
                                :disabled="!editable"
                                :placeholder="$t('global.status')"
                              >
                                <span slot="no-options">{{
                                  $t("notification.taptosearch")
                                }}</span>
                              </v-select>
                              <label v-bind:class="{ 'text-danger': !passed }">{{
                                $t("global.status")
                              }}</label>
                            </ValidationProvider>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-6">
                      <div class="row">
                        <div class="col-xl-12">
                          <div class="form-group">
                            <ValidationProvider
                              rules="required"
                              immediate
                              v-slot="{ passed }"
                            >
                              <v-select
                                v-model="anmeldung.anmeldetyp"
                                label="bezeichnung"
                                v-bind:class="{ 'border-info': !passed }"
                                :options="anmeldetypen"
                                :disabled="!editable"
                                :placeholder="$t('dashboard.type')"
                              >
                                <span slot="no-options">{{
                                  $t("notification.taptosearch")
                                }}</span>
                              </v-select>
                              <label v-bind:class="{ 'text-danger': !passed }">{{
                                $t("dashboard.type")
                              }}</label>
                            </ValidationProvider>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-6">
                      <single-select-person
                        id="anmeldung-von"
                        :person="anmeldung.person"
                        :label="$t('global.person')"
                        :allowOpen="berechtigungen.m_geschaeftspartner.read"
                        required
                        :editable="editable"
                        @confirmed="setPerson"
                      />
                    </div>
                    <div class="col-xl-6">
                      <single-select-veranstaltung
                        id="anmeldung-veranstaltung"
                        :veranstaltung="anmeldung.veranstaltung"
                        :label="$t('global.event')"
                        :allowOpen="berechtigungen.m_bildung.read"
                        :editable="editable"
                        required
                        @confirmed="setVeranstaltung"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <v-select
                          v-model="anmeldung.abschluss"
                          label="bezeichnung"
                          :options="abschluesse"
                          :disabled="!editable"
                          :placeholder="$t('global.degree')"
                        >
                          <span slot="no-options">{{
                            $t("notification.taptosearch")
                          }}</span>
                        </v-select>
                        <label>{{ $t("global.degree") }}</label>
                      </div>
                    </div>
                    <div
                      v-if="
                        editable &&
                        anmeldungid &&
                        anmeldung.veranstaltung.veranstaltungstyp.istklasse ==
                          false
                      "
                      class="col-xl-6"
                    >
                      <div class="form-group">
                        <v-select
                          v-model="anmeldung.niveau"
                          label="bezeichnung"
                          :options="niveaus"
                          :disabled="!editable"
                          placeholder="Niveau"
                        >
                          <span slot="no-options">{{
                            $t("notification.taptosearch")
                          }}</span>
                        </v-select>
                        <label>Niveau</label>
                      </div>
                    </div>
                    <div
                      v-if="
                        editable &&
                        anmeldungid &&
                        anmeldung.veranstaltung.veranstaltungstyp.istklasse ==
                          true
                      "
                      class="col-xl-6"
                    >
                      <div class="form-group">
                        <v-select
                          v-model="anmeldung.kompetenzraster"
                          label="bezeichnung"
                          :options="kompetenzrasters"
                          :disabled="!editable"
                          :placeholder="$t('global.competencegrid')"
                        >
                          <span slot="no-options">{{
                            $t("notification.taptosearch")
                          }}</span>
                        </v-select>
                        <label>{{ $t("global.competencegrid") }}</label>
                      </div>
                    </div>
                    <div class="col-xl-6"></div>
                  </div>
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <v-select
                          v-model="anmeldung.anmeldegrund"
                          multiple
                          label="bezeichnung"
                          :options="anmeldegruende"
                          :disabled="!editable"
                          :placeholder="$t('global.reasonforregistration')"
                        >
                          <span slot="no-options">{{
                            $t("notification.taptosearch")
                          }}</span>
                        </v-select>
                        <label>{{ $t("global.reasonforregistration") }}</label>
                      </div>
                    </div>
                    <div class="col-xl-6">
                      <div v-if="anmeldung" class="form-group">
                        <v-select
                          v-model="anmeldung.abmeldegrund"
                          multiple
                          label="bezeichnung"
                          :options="abmeldegruende"
                          :disabled="!editable"
                          :placeholder="$t('global.reasonforderegistration')"
                        >
                          <span slot="no-options">{{
                            $t("notification.taptosearch")
                          }}</span>
                        </v-select>
                        <label>{{ $t("global.reasonforderegistration") }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <v-select
                          v-model="anmeldung.ablehnungsgrund"
                          label="bezeichnung"
                          :options="ablehnunggruende"
                          :disabled="!editable"
                          :placeholder="$t('global.reasonforrejection')"
                        >
                          <span slot="no-options">{{
                            $t("notification.taptosearch")
                          }}</span>
                        </v-select>
                        <label>{{ $t("global.reasonforrejection") }}</label>
                      </div>
                    </div>
                    <div class="col-xl-6"></div>
                  </div>
                  <div class="row">
                    <div class="col-xl-12">
                      <div class="form-group">
                        <textarea
                          v-model.trim="anmeldung.bemerkung"
                          class="form-control"
                          placeholder=" "
                          :readonly="!editable"
                        ></textarea>
                        <label>{{ $t("global.comment") }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            -->
          </div>
          <!-- ENDE Stammdaten -->
          <!-- START Verlauf -->
          <div v-if="produktid">
            <container-headline
              :headline="$t('global.process')"
              :col="6"
            ></container-headline>
            <div class="row mb-3">
              <!--
                <div class="col-xl-12 block br-t-l-0">
                  <div class="eingabe-panel-kopf p-3">
                    <div class="row">
                      <div class="col-xl-2">
                        <div class="form-group">
                          <date-picker
                            date-format="dd.mm.yy"
                            :initial="anmeldung.anmeldungsdatum"
                            :disabled="!editable"
                            @update="(val) => (anmeldung.anmeldungsdatum = val)"
                          />
                          <label>{{ $t("global.registration") }}</label>
                        </div>
                      </div>
                      <div class="col-xl-2">
                        <div class="form-group">
                          <input
                            v-model.trim="anmeldung.anmeldungsdatum_uhrzeit"
                            class="form-control"
                            :readonly="!editable"
                          />
                          <label>{{ $t("global.Time") }}</label>
                        </div>
                      </div>
                      <div class="col-xl-2">
                        <div class="form-group">
                          <date-picker
                            date-format="dd.mm.yy"
                            :initial="anmeldung.abgemeldet"
                            :disabled="!editable"
                            @update="(val) => (anmeldung.abgemeldet = val)"
                          />
                          <label>{{ $t("global.canceld") }}</label>
                        </div>
                      </div>
                      <div class="col-xl-2">
                        <div class="form-group">
                          <input
                            v-model.trim="anmeldung.abgemeldet_uhrzeit"
                            class="form-control"
                            :readonly="!editable"
                          />
                          <label>{{ $t("global.Time") }}</label>
                        </div>
                      </div>
                      <div class="col-xl-2">
                        <div class="form-group">
                          <date-picker
                            date-format="dd.mm.yy"
                            :initial="anmeldung.warteliste"
                            :disabled="!editable"
                            @update="(val) => (anmeldung.warteliste = val)"
                          />
                          <label>{{ $t("global.waitinglist") }}</label>
                        </div>
                      </div>
                      <div class="col-xl-2">
                        <div class="form-group">
                          <input
                            v-model.trim="anmeldung.warteliste_uhrzeit"
                            class="form-control"
                            :readonly="!editable"
                          />
                          <label>{{ $t("global.Time") }}</label>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-2">
                        <div class="form-group">
                          <date-picker
                            date-format="dd.mm.yy"
                            :initial="anmeldung.gebucht"
                            :disabled="!editable"
                            @update="(val) => (anmeldung.gebucht = val)"
                          />
                          <label>{{ $t("global.booked") }}</label>
                        </div>
                      </div>
                      <div class="col-xl-2">
                        <div class="form-group">
                          <input
                            v-model.trim="anmeldung.gebucht_uhrzeit"
                            class="form-control"
                            :readonly="!editable"
                          />
                          <label>{{ $t("global.Time") }}</label>
                        </div>
                      </div>
                      <div class="col-xl-2">
                        <div class="form-group">
                          <date-picker
                            date-format="dd.mm.yy"
                            :initial="anmeldung.abgelehnt"
                            :disabled="!editable"
                            @update="(val) => (anmeldung.abgelehnt = val)"
                          />
                          <label>{{ $t("global.rejected") }}</label>
                        </div>
                      </div>
                      <div class="col-xl-2">
                        <div class="form-group">
                          <input
                            v-model.trim="anmeldung.abgelehnt_uhrzeit"
                            class="form-control"
                            :readonly="!editable"
                          />
                          <label>{{ $t("global.Time") }}</label>
                        </div>
                      </div>
                      <div class="col-xl-2">
                        <div class="form-group">
                          <date-picker
                            date-format="dd.mm.yy"
                            :initial="anmeldung.besucht"
                            :disabled="!editable"
                            @update="(val) => (anmeldung.besucht = val)"
                          />
                          <label>{{ $t("global.visited") }}</label>
                        </div>
                      </div>
                      <div class="col-xl-2">
                        <div class="form-group">
                          <input
                            v-model.trim="anmeldung.besucht_uhrzeit"
                            class="form-control"
                            :readonly="!editable"
                          />
                          <label>{{ $t("global.Time") }}</label>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-2">
                        <div class="form-group">
                          <date-picker
                            date-format="dd.mm.yy"
                            :initial="anmeldung.zurueckgestellt"
                            :disabled="!editable"
                            @update="(val) => (anmeldung.zurueckgestellt = val)"
                          />
                          <label>{{ $t("global.deferred") }}</label>
                        </div>
                      </div>
                      <div class="col-xl-2">
                        <div class="form-group">
                          <input
                            v-model.trim="anmeldung.zurueckgestellt_uhrzeit"
                            class="form-control"
                            :readonly="!editable"
                          />
                          <label>{{ $t("global.Time") }}</label>
                        </div>
                      </div>
                      <div class="col-xl-2">
                        <div class="form-group">
                          <date-picker
                            date-format="dd.mm.yy"
                            :initial="anmeldung.noteneingabe"
                            :disabled="!editable"
                            @update="(val) => (anmeldung.noteneingabe = val)"
                          />
                          <label>{{ $t("dashboard.scoreinput") }}</label>
                        </div>
                      </div>
                      <div class="col-xl-2">
                        <div class="form-group">
                          <input
                            v-model.trim="anmeldung.noteneingabe_uhrzeit"
                            class="form-control"
                            :readonly="!editable"
                          />
                          <label>{{ $t("global.Time") }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            --></div>
          </div>
          <!-- ENDE Verlauf -->
        </div>
        <!-- ENDE linke Seite -->
        <!-- START Rechte Seite -->
        <div class="col-xl-6 pl-4" :class="{ 'col-xl-12': !showNavbar }">
          <!-- START Finanzen und Rechnung -->
          <container-headline
            :headline="$t('global.financesandinvoice')"
            :col="6"
          ></container-headline>
          <div class="row mb-3">
            <!--
              <div class="col-xl-12 block br-t-l-0">
                <div class="eingabe-panel-kopf p-3">
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <v-select
                          v-model="anmeldung.verrechnung"
                          multiple
                          label="bezeichnung"
                          :options="verrechnungen"
                          :disabled="!editable"
                          :placeholder="$t('global.offsetting')"
                        >
                          <span slot="no-options">{{
                            $t("notification.taptosearch")
                          }}</span>
                        </v-select>
                        <label>{{ $t("global.offsetting") }}</label>
                      </div>
                    </div>
                    <div class="col-xl-6">
                      <div class="form-group">
                        <v-select
                          v-model="anmeldung.zahlungsplan"
                          label="bezeichnung"
                          :options="zahlungsplaene"
                          :disabled="!editable"
                          :placeholder="$t('global.paymentschedule')"
                        >
                          <span slot="no-options">{{
                            $t("notification.taptosearch")
                          }}</span>
                        </v-select>
                        <label>{{ $t("global.paymentschedule") }}</label>
                      </div>
                    </div>
                    <div class="col-xl-6"></div>
                  </div>
                  <div class="row">
                    <div class="col-xl-12">
                      <div class="form-group">
                        <textarea
                          v-model.trim="anmeldung.rechnungshinweis"
                          class="form-control"
                          placeholder=" "
                          :disabled="!editable"
                        ></textarea>
                        <label>{{ $t("global.invoicenotice") }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-12">
                      <div class="form-group">
                        <textarea
                          v-model.trim="anmeldung.adresszusatz"
                          class="form-control"
                          placeholder=" "
                          :disabled="!editable"
                        ></textarea>
                        <label>{{ $t("global.addresssuffix") }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            -->
          </div>
          <!-- ENDE Finanzen und Rechnung -->
          <!--START Rechnungsplit -->
          <container-headline
            :headline="$t('global.invoicesplit')"
            :col="6"
          ></container-headline>
          <div class="row mb-3">
            <!--
              <div class="col-xl-12 block br-t-l-0">
                <div class="eingabe-panel-kopf p-3">
                  <div class="row">
                    <div class="col-xl-5">
                      <single-select-firma
                        id="firma-rechnungs-split"
                        :rechnungstraeger="anmeldung.person.id"
                        :firma="anmeldung.firma_rechnungssplit"
                        :key="'firmakey ' + firmakey"
                        :editable="editable"
                        :allowOpen="true"
                        :label="'2. ' + $t('global.invoicepartycompany')"
                        @confirmed="setFirmaRechnungssplit"
                      />
                    </div>
                    <div class="col-xl-5">
                      <single-select-person
                        id="person-rechnungs-split"
                        :person="anmeldung.person_rechnungssplit"
                        :firma="anmeldung.firma_rechnungssplit"
                        :label="'2. ' + $t('global.invoicepartyperson')"
                        :allowOpen="true"
                        :rollen="filterRollen"
                        :editable="editable"
                        @confirmed="setPersonRechungssplit"
                      />
                    </div>
                    <div class="col-xl-2">
                      <div class="form-group">
                        <input
                          v-model.number="anmeldung.anteil"
                          class="form-control"
                          placeholder=" "
                          :readonly="!editable"
                        />
                        <label>{{ $t("global.shareinpercent") }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-12">
                      <div class="form-group">
                        <v-select
                          v-model="anmeldung.adresse_rechnungssplit"
                          label="adresseKomplett"
                          :options="adressenVerbObjects"
                          :disabled="!editable"
                          :placeholder="$t('global.addressesinvoicesplit')"
                        >
                          <span slot="no-options">{{
                            $t("notification.taptosearch")
                          }}</span>
                        </v-select>
                        <label>{{ $t("global.addressesinvoicesplit") }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="form-group">
                        <textarea
                          v-model.trim="anmeldung.rg_adresse_zusatz"
                          class="form-control"
                          placeholder=" "
                          rows="4"
                        />
                        <label>{{ $t("global.invoiceaddressaddition") }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            -->
          </div>
          <!--ENDE Rechnungsplit -->
        </div>
        <!-- ENDE Rechte Seite -->
      </div>
    </ValidationObserver>

    <loading-overlay v-show="loading"></loading-overlay>

    <loeschen-modal id="produkt-loeschen-modal" @confirmed="produktLoeschen" />

    <change-watcher-alert />
  </div>
</template>
  
  <script>
import Api from "@/Api";
import page from "@/mixins/Page";
import ChangeWatcher from "@/mixins/ChangeWatcher";
import server from "@/server";

import HeadMenu from "@/components/HeadMenu";
import ContainerHeadline from "@/components/ContainerHeadline";
import DatePicker from "@/components/Datepicker";
import Navbar from "@/components/Navbar";

import LoeschenModal from "@/components/Modals/LoeschenModal.vue";

import { apiErrorToAlert } from "@/utils/Errorhandler";

import store from "@/store";

import { textNotLinked } from "@/defaultTexts.js";

export default {
  name: "Produkt",
  components: {
    HeadMenu,
    Navbar,
    ContainerHeadline,
    LoeschenModal,
  },
  mixins: [page, ChangeWatcher],
  store,
  props: {
    produktid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      produkt: {
        bezeichnung: [{ de: "" }, { en: "" }, { it: "" }, { es: "" }],
      },
    };
  },
  computed: {
    navbarTitel: function () {
      if (this.id || this.produktid) {
        return this.$t("global.product");
      } else {
        return this.$t("global.newproduct");
      }
    },
  },
  watch: {},

  created() {},

  mounted() {},

  methods: {
    abbrechen() {
      this.$router.push({ name: "anmeldungen-liste" });
    },

    speichern() {},

    oeffneLoeschenModal() {
      this.$bus.$emit("openLoeschenModal", "produkt-loeschen-modal");
    },

    produktLoeschen() {},
  },
};
</script>
  
  <style>
</style>
  